import styled from 'styled-components';

import { PLAYER_PLACEHOLDER } from '#src/constants/assets.ts';

import type { VariantStyle } from './types.ts';

type Props = {
  name: string;
  avatarUrl: string | null;
  variant?: VariantStyle;
  className?: string;
};

const Root = styled.img`
  width: var(--size, calc(var(--unit) * 5));
  height: var(--size, calc(var(--unit) * 5));
  user-select: none;
  border-radius: var(--unit);
  object-fit: contain;
  &[data-variant='medallion'] {
    border-radius: 50%;
  }
`;

export const DumbPlayerAvatar = (props: Props) => {
  const { name, avatarUrl, variant = 'rounded', className } = props;

  return (
    <Root
      className={className}
      data-variant={variant}
      alt={name}
      src={avatarUrl || PLAYER_PLACEHOLDER}
    />
  );
};
